import { FC } from "react";
import styles from "./RulesOfPay.module.scss";
import classNames from "classnames";

// import FileDocument from "../../../files/rulesPay.docx";

interface RulesOfPayProps {
  classess?: string;
}

const RulesOfPay: FC<RulesOfPayProps> = ({ classess }) => {
  return (
    <div className={classNames(styles.RulesOfPay, {}, [classess])}>
      <p className={styles.head}>
        Приложение 1 к приказу главного врача ООО «Денталика» от 11.01.2021 № 1
      </p>

      <h1>
        Положение о порядке предоставления Обществом с ограниченной
        ответственностью «Денталика» платных медицинских услуг
      </h1>

      <h3>I. Общие положения</h3>
      <p>
        <b>1.1. </b>Настоящее Положение о порядке предоставления Обществом с
        ограниченной ответственностью «Денталика» платных медицинских услуг
        определяют порядок и условия предоставления платных медицинских услуг.
        Настоящее Положение разработано на основании: - Конституции Российской
        Федерации; - Гражданского кодекса Российской Федерации; - Закона РФ от
        21.11.2011. № 323-ФЗ «Об основах охраны здоровья граждан Российской
        Федерации»; - Закона РФ от 07.02.1992. № 2300-1 «О защите прав
        потребителей»; - Закона РФ от 27.07.2006. № 152-ФЗ «О персональных
        данных»; - Постановления Правительства Российской Федерации от
        04.10.2012. № 1006 «Об утверждении правил предоставления медицинскими
        организациями платных медицинских услуг».
        <br /> <b>1.2.</b> Для целей настоящего Положения используются следующие
        основные понятия: «платные медицинские услуги» — медицинские услуги,
        предоставляемые на возмездной основе за счет личных средств граждан,
        средств юридических лиц и иных средств на основании договора, в том
        числе договоров добровольного медицинского страхования (ДМС) (далее –
        договор); «потребитель» — физическое лицо, имеющее намерение получить
        либо получающее платные медицинские услуги лично в соответствии с
        договором. Потребитель, получающий платные медицинские услуги, является
        пациентом, на которого распространяется действие Федерального закона «Об
        основах охраны здоровья граждан в Российской Федерации»; «заказчик» —
        физическое (юридическое) лицо, имеющее намерение заказать (приобрести)
        либо заказывающее (приобретающее) платные медицинские услуги в
        соответствии с договором в пользу потребителя; «исполнитель» -
        медицинская организация, предоставляющая платные медицинские услуги
        потребителям ООО «Денталика» (далее по тексту – Клиника).
        <br /> <b>1.3.</b> Платные медицинские услуги в Клинике предоставляются
        на основании перечня работ (услуг), составляющих медицинскую
        деятельность и указанных в лицензии на осуществлении медицинской
        деятельности, выданной в установленном порядке.
        <br /> <b>1.4. </b> Требования к платным медицинским услугам, в том
        числе к их объему и срокам оказания, определяются по отношению сторон
        договора, если федеральными законами, иными нормативными правовыми
        актами Российской Федерации не предусмотрены другие требования.
        <br /> <b> 1.5.</b> Настоящее Положение в наглядной и доступной форме
        доводятся исполнителем до сведения потребителя (заказчика).
        <br /> <b> 1.6. </b>Общее руководство деятельностью по предоставлению
        платных услуг осуществляет главный врач Клиники.
        <br /> <b> 1.7.</b> При оказании платных медицинских услуг
        осуществляется внутренний контроль качества и безопасности медицинской
        деятельности в порядке, установленном главным врачом Клиники. При
        оказании платных медицинских услуг также проводится государственный и
        ведомственный контроль качества и безопасности медицинской деятельности
        в порядке, предусмотренном действующим законодательством.
        <br /> <b>1.8.</b> Настоящее Положение в наглядной и доступной форме
        доводятся Клиникой до сведения потребителя (заказчика).
      </p>

      <h3>II. Условия предоставления платных медицинских услуг</h3>
      <p>
        <b>2.1 </b>Клиника определяет цены (тарифы) на предоставление платных
        медицинских услуг самостоятельно. Стоимость медицинской помощи или цена
        отдельной медицинской услуги, предоставляемой Клиникой, определяется из
        утвержденного Прейскуранта Клиники.
        <br /> <b>2.2 </b> Клиника предоставляет платные медицинские услуги в
        полном объеме стандарта медицинской помощи, утвержденного Министерством
        здравоохранения РФ, либо по просьбе потребителя в виде осуществления
        отдельных консультаций или медицинских вмешательств, в том числе в
        объеме, превышающем объем выполняемого стандарта медицинской помощи.
        <br /> <b>2.3 </b> При предоставлении платных медицинских услуг должны
        соблюдаться порядки оказания медицинской помощи, утвержденные
        Министерством здравоохранения Российской Федерации.
      </p>

      <h3>
        III. Информация об исполнителе и предоставляемых им медицинских услуг
      </h3>

      <p>
        <b> 3.1. </b>Клиника предоставляет посредством размещения на
        информационном стенде по адресу: г. Ревда, ул. Горького,2 информацию,
        содержащую следующие сведения:
        <br /> <b> а)</b> полное наименование Клиники, адрес места нахождения
        Клиники:
        <br /> <b> б) </b> данные документа, подтверждающего факт внесения
        сведений о юридическом лице в Единый государственный реестр юридических
        лиц, с указанием органа, осуществившего государственную регистрацию:
        <br /> <b> в)</b> копию лицензии на осуществлении медицинской
        деятельности: (номер и дата регистрации, перечень работ (услуг),
        составляющих медицинскую деятельность медицинской организации в
        соответствии с лицензией, наименование, адрес места нахождения и телефон
        выдавшего ее лицензирующего органа; <br /> <b> г) </b> прейскурант
        платных медицинских услуг, утвержденный главным врачом Клиники с
        указанием цен в рублях; <br /> <b> д) </b>настоящее Положение о порядке
        предоставления ООО «Денталика» платных медицинских услуг; <br />{" "}
        <b> е)</b>
        сведения о медицинских работниках, участвующих в предоставлении платных
        медицинских услуг, об уровне их профессионального образования и
        квалификации; <br /> <b> ё) </b>режим работы Клиники, график работы
        медицинских работников, участвующих в предоставлении платных медицинских
        услуг;
        <br /> <b> ж) </b> адреса и телефоны органа исполнительной власти
        субъекта Российской федерации в сфере охраны здоровья граждан,
        территориального органа Федеральной службы по надзору в сфере защиты
        прав потребителей и благополучия человека.
        <br /> <b> 3.2. </b> При заключении договора Клиника по требованию
        потребителя и (или) заказчика предоставляет в доступной форме информацию
        о платных медицинских услугах, содержащую следующие сведения:
        <br /> <b> а)</b> порядки оказания медицинской помощи и стандарты
        медицинской помощи, применяемые при предоставлении платных медицинских
        услуг;
        <br />
        <b> б)</b> информацию о конкретном медицинском работнике,
        предоставляющем соответствующую платную медицинскую услугу (его
        профессиональном образовании и квалификации);
        <br /> <b> в) </b> информацию о методах оказания медицинской помощи,
        связанных с ними рисках, возможных видах медицинского вмешательства, их
        последствиях и ожидаемых результатах оказания медицинской помощи;
        <br /> <b> г) </b> другие сведения, относящиеся к предмету договора.
        <br /> <b> 3.3. </b>До заключения договора исполнитель в письменной
        форме уведомляет потребителя (заказчика): - о том, что несоблюдение
        указаний (рекомендаций) исполнителя (медицинского работника,
        предоставляющего платную услугу), в том числе назначенного режима
        лечения, могут снизить качество предоставляемой платной медицинской
        услуги, повлечь за собой невозможность ее завершения в срок или
        отрицательно сказаться на состоянии здоровья потребителя (заказчика); -
        о возможности получения медицинской помощи в рамках программы
        государственных гарантий бесплатного оказания гражданам медицинской
        помощи и территориальных программ государственных гарантий бесплатного
        оказания гражданам медицинской помощи.
      </p>

      <h3>IV. Порядок заключения договора и оплаты медицинских услуг</h3>

      <p>
        <b>4.1. </b>Договор заключается потребителем (заказчиком) и ООО
        «Денталика» в письменной форме.
        <br /> <b> 4.2.</b> Договор должен содержать: - сведения об исполнителе:
        наименование Клиники, адрес места нахождения, данные документа,
        подтверждающего факт внесения сведений о юридическом лице в Единый
        государственный реестр юридических лиц, с указанием органа,
        осуществившего государственную регистрацию; - номер лицензии на
        осуществление медицинской деятельности, дата ее регистрации с указанием
        перечня работ (услуг), составляющих медицинскую деятельность медицинской
        организации в соответствии с лицензией, наименование, адрес места
        нахождения и телефон выдавшего ее лицензирующего органа; - фамилию, имя
        и отчество (если имеется), адрес места жительства и телефон потребителя
        (законного представителя потребителя). Договор может быть заключен
        анонимно согласно ч.5 ст. 84 Закона от 21.11.2011 № 323-ФЗ (пп. «б» п.
        17 Постановления Правительства РФ от 04.10.2012 № 1006); - фамилию, имя
        и отчество (если имеется), адрес места жительства и телефон заказчика -
        физического лица; наименование и адрес места нахождения заказчика -
        юридического лица; - условия и сроки предоставления платных медицинских
        услуг; - должность, фамилию, имя, отчество (если имеется) лица,
        заключающего договор от имени ООО «Денталика», и его подпись, фамилию,
        имя, отчество (если имеется) потребителя (заказчика) и его подпись. В
        случае если заказчик является юридическим лицом, указывается должность
        лица, заключающего договор от имени заказчика; - ответственность сторон
        за невыполнение условий договора; - порядок изменения и расторжения
        договора; - иные условия, определяемые по соглашению сторон или
        Правилами предоставления платных медицинских услуг, утвержденными
        Постановлением правительства РФ.
        <br /> <b> 4.3.</b> Стороны (исполнитель, потребитель, заказчик) вправе
        согласовать перечень платных медицинских услуг, их стоимость, сроки
        оказания услуг,{" "}
        <strong>
          а также подтвердить факт оказания услуг (выполнения работ) путем
          подписания Акта об оказанных услугах к договору, являющихся
          неотъемлемой частью договора.
        </strong>{" "}
        <br />
        <b> 4.4.</b> Договор на оказание платных медицинских услуг оформляется и
        хранится в медицинской карте амбулаторного пациента Клиники,
        подписывается главным врачом или иным лицом на основании доверенности,
        выданной главным врачом. В установленные сроки договоры передаются в
        архив. Договор составляется в 3 экземплярах, один из которых находится в
        Клинике (регистратура), второй - у заказчика, третий - у потребителя. В
        случае если договор заключается потребителем и ООО «Денталика» , он
        составляется в 2 экземплярах.
        <br /> <b> 4.5.</b> На предоставление платных медицинских услуг по
        требованию заказчика (потребителя) может быть составлена смета.
        <br /> <b> 4.6.</b> В случае, если при предоставлении платных
        медицинских услуг потребуется предоставление дополнительных медицинских
        услуг по экстренным показаниям для устранения угрозы жизни потребителя
        при внезапных острых заболеваниях, состояниях, обострениях хронических
        заболеваний, такие медицинские услуги оказываются без взимания платы в
        соответствии с Федеральным законом "Об основах охраны здоровья граждан в
        Российской Федерации".
        <br /> <b> 4.7.</b> В случае отказа потребителя после заключения
        договора от получения медицинских услуг договор расторгается. ООО
        «Денталика» информирует потребителя (заказчика) о расторжении договора
        по инициативе потребителя, при этом потребитель (заказчик) оплачивает
        ООО «Денталика» фактически понесенные исполнителем расходы, связанные с
        исполнением обязательств по договору.
        <br /> <b> 4.8.</b> Потребитель (заказчик) обязан оплатить
        предоставленную ООО «Денталика» медицинскую услугу в сроки и в порядке,
        которые определены договором.
        <br /> <b> 4.9.</b> Потребителю (заказчику) в соответствии с
        законодательством Российской Федерации выдается документ, подтверждающий
        произведенную оплату предоставленных медицинских услуг
        (контрольно-кассовый чек, квитанция или иной бланк строгой отчетности
        (документ установленного образца)).
        <br /> <b> 4.10.</b> После исполнения договора по требованию потребителя
        (законного представителя потребителя) на основании заявления выдается
        копия медицинских документов, выписка из медицинских документов,
        отражающие состояние его здоровья после получения платных медицинских
        услуг.
        <br /> <b> 4.11.</b> Заключение договора добровольного медицинского
        страхования и оплата медицинских услуг, предоставляемых в соответствии с
        указанным договором, осуществляются в соответствии с Гражданским
        кодексом Российской Федерации и Законом Российской Федерации "Об
        организации страхового дела в Российской Федерации".
      </p>

      <h3>V. Порядок предоставления платных медицинских услуг</h3>

      <p>
        <b>5.1.</b> Оказание платных услуг осуществляют штатные специалисты ООО
        «Денталика». Качество платных медицинских услуг должно соответствовать
        условиям договора, а при отсутствии в договоре условий об их качестве -
        требованиям, предъявляемым к услугам соответствующего вида.
        <br /> <b>5.2.</b> В случае если федеральным законом, иными нормативными
        правовыми актами Российской Федерации предусмотрены обязательные
        требования к качеству медицинских услуг, качество предоставляемых
        платных медицинских услуг должно соответствовать этим требованиям.
        <br />
        <b>5.3.</b> Платные медицинские услуги предоставляются при наличии
        информированного добровольного согласия потребителя (законного
        представителя потребителя), данного в порядке, установленном
        законодательством Российской Федерации об охране здоровья граждан.
        <br /> <b>5.4.</b> Лечащий врач Клиники предоставляет потребителю
        (законному представителю потребителя) по его требованию и в доступной
        для него форме информацию: - о состоянии его здоровья, включая сведения
        о результатах обследования, диагнозе, методах лечения, связанном с ними
        риске, возможных вариантах и последствиях медицинского вмешательства,
        ожидаемых результатах лечения; - об используемых при предоставлении
        платных медицинских услуг лекарственных препаратах и медицинских
        изделиях, в том числе о сроках их годности (гарантийных сроках),
        показаниях (противопоказаниях) к применению.
        <br /> <b>5.5.</b> Клиника обязана при оказании платных медицинских
        услуг соблюдать установленные законодательством Российской Федерации
        требования к оформлению и ведению медицинской документации и учетных и
        отчетных статистических форм, порядку и срокам их представления.
      </p>

      <h3>VI. Порядок ведения бухгалтерского учета</h3>

      <p>
        <b>6.1.</b> ООО Денталика» ведет бухгалтерский учет, представляет
        бухгалтерскую отчетность в порядке, установленном законодательством
        Российской Федерации.
        <br /> <b>6.2.</b> Клиника предоставляет информацию о своей деятельности
        в налоговые органы, иные органы в соответствии с законодательством
        Российской Федерации и своим Уставом.
      </p>

      <h3>
        VII. Ответственность и контроль за предоставлением платных медицинских
        услуг
      </h3>

      <p>
        <b>7.1. </b> За неисполнение либо ненадлежащее исполнение обязательств
        по договору на оказание платных медицинских услуг исполнитель несет
        ответственность, предусмотренную законодательством Российской Федерации.
        <br />
        <b>7.2. </b> Вред, причиненный жизни или здоровью пациента в результате
        предоставления некачественной платной медицинской услуги, подлежит
        возмещению исполнителем в соответствии с законодательством Российской
        Федерации.
        <br /> <b>7.3. </b> Контроль за соблюдением Правил предоставления
        медицинскими организациями платных медицинских услуг», утвержденных
        Постановлением Правительства РФ от 04.10.2012 года № 1006, осуществляет
        Федеральная служба по надзору в сфере защиты прав потребителей и
        благополучия человека в рамках установленных полномочий.
        <br /> <b>7.4. </b> Приказом главного врача ООО «Денталика» утверждается
        настоящее положение и лицо, ответственное за соблюдение Положения о
        порядке предоставления ООО «Денталика» платных медицинских услуг.
      </p>

      <h3>VIII. Заключительные положения.</h3>

      <p>
        <b>8.1.</b> Все изменения и дополнения к настоящему Положению
        утверждаются приказом главного врача ООО «Денталика».
      </p>

      <a href="./rulesPay.docx" download>
        Скачать документ
      </a>
    </div>
  );
};

export default RulesOfPay;
